module.exports = __webpack_public_path__ + "5dd9daf54f2548f5961fc7288059b70c.svg";